<template>

  <InfoValidazioneCredito />

</template>

<script>
import InfoValidazioneCredito from '../components/ask/pages/InfoValidazioneCredito.vue'

export default {
  pageName: 'InfoValidazioneCredito',
  components: {
    InfoValidazioneCredito

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
